import React from "react";
import { useRecordContext } from "react-admin";

type UnitPriceFieldProps = {
  sortable?: boolean;
  source: string;
};

export const UnitPriceField = (props: UnitPriceFieldProps) => {
  const record = useRecordContext();

  if (record === undefined) {
    return null;
  }

  const price: number = record[props.source];

  return <span {...props}>{`${price.toLocaleString()}円以上`}</span>;
};
